import { gql } from "@apollo/client"

export type EledoConnection = {
  id: string
  type: string
  description: string
  updated: Date
  status: string
}

export type EledoApiKeyConnection = EledoConnection & {
  apiKey: string
}

export type EledoConnections = {
  total: number
  items: [EledoConnection]
}

export type EledoConnectionsData = {
  connections: EledoConnections
}

export type EledoConnectionsVars = {
  limit?: number
  page?: number
}

export const GET_CONNECTIONS = gql`
  query getConnections($limit: Int, $page: Int) {
    connections(limit: $limit, page: $page) { items { id type description updated status } total }
  }
`;